import React, { Component } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer'; 
import DataTable from 'react-data-table-component';
import { BaseUrl } from '../common/config';
import Sidebar from '../common/sidebar';
import { http } from '../helper';
import { capitalizeFirstLetter } from "../utilityfunctions";
import moment from 'moment';
import { canAction } from '../common/permissionhelper';
import Popup from '../common/popup';
class Chefs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTextVal: "",
      chefsList: [],
      tempList: [],
      loading: true,
      visibleAlert: false,
      selectedChef: null, // Store the chef data for deletion
      showViewPopup: false,
      selectedChefDetails: null,
    };

    // Check for session and authorization
    if (!sessionStorage.getItem("isLoggedIn")) {
      window.location.href = '/';
    }
    if (JSON.parse(sessionStorage.getItem('authData')) != '' && !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_chefs')) {
      window.location.href = '/unauthorized';
    }
  }

  // Fetch the list of chefs
  getChefsList() {
    let URL = `${BaseUrl}admin/getchefs`;
    http.get(URL).then((response) => {
      let responseData = response.data.data;
      this.setState({ chefsList: responseData, loading: false, tempList: responseData });
    }).catch((err) => {
      console.log(err);
    });
  }

  // Edit chef details (navigate to edit page)
  editChefDetails = (editId) => {
    window.location.href = `/development-chef/edit/${editId}`;
  };

  // Delete chef (open confirmation alert)
  deleteChef = (chef) => {
    this.setState({ visibleAlert: true, selectedChef: chef });
  };

  // Confirm deletion
  deleteChefDetails = () => {
    const { selectedChef } = this.state;
    let URL = `${BaseUrl}admin/deletechefs/${selectedChef._id}`;
    http.delete(URL).then((response) => {
      if (response.data.success === true) {
        window.location.reload();
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  // Close delete confirmation alert
  alertPopupClose = () => {
    this.setState({ visibleAlert: false, selectedChef: null });
  };

  // Filter chefs based on search input
  handleChange = async (value) => {
    this.setState({ searchTextVal: value });
    this.filterData(value);
  };

  // Apply filter to chefs list
  filterData = (value) => {
    let chefs = this.state.tempList;
    const lowercasedValue = value.toLowerCase().trim();
    let result = [];
    if (lowercasedValue.length > 0) {
      chefs.map((item) => {
        if (item.groupName.toString().toLowerCase().includes(lowercasedValue)) {
          result.push(item);
        }
      });
      this.setState({ chefsList: result });
    } else {
      this.setState({ chefsList: chefs });
    }
  };

  // Reset search filter
  handleReset = () => {
    this.setState({ searchTextVal: '', chefsList: this.state.tempList });
  };

  // Component mount lifecycle method
  componentDidMount() {
    this.getChefsList();
  }

  // Add a new chef
  addChef = () => {
    window.location.href = '/development-chef/add';
  };
  viewChefDetails = (chef) => {
    this.setState({
      showViewPopup: true,
      selectedChefDetails: chef,
    });
  };

  closeViewPopup = () => {
    this.setState({
      showViewPopup: false,
      selectedChefDetails: null,
    });
  };
  render() {
    const columns = [
      {
        name: "Group Name",
        selector: row => row.groupName,
        sortable: true,
      },
      {
        name: "Primary Account",
        selector: row => row.primaryAccount ? `${row.primaryAccount.accountCode} - ${row.primaryAccount.accountName}`: '',
        sortable: true,
      },
      {
        name: "Status",
        selector: row => capitalizeFirstLetter(row.groupStatus),
        sortable: true,
      },
      {
       name: "Date Created",
       selector: row => moment(row.createdAt).format('DD-MM-YYYY HH:mm A'),
       sortable: true,
      },  
      {
        name: "Actions",
        selector: row => {
          return (
            <div style={{ display: "flex" }}>
              {canAction('manage_chefs', 'view') && (
              <a className='editbtn button title-tooltip title-up' data-title='View' style={{ color: "white" }} onClick={() => this.viewChefDetails(row)}>
                <i className="fa fa-eye" aria-hidden="true"></i>
              </a>
              )}
              {canAction('manage_chefs', 'edit') && (
              <a className='editbtn button title-tooltip title-up' data-title='Edit' style={{ color: "white" }} onClick={() => this.editChefDetails(row._id)}>
                <i className={`fa ${canAction('manage_chefs', 'edit') ? 'fa-pencil' : 'fa-eye'}`} aria-hidden="true"></i>
              </a>
              )}
              {canAction('manage_chefs', 'delete') && (
              <a className='editbtn button title-tooltip title-up' data-title='Delete' style={{ color: "white" }} onClick={() => this.deleteChef(row)}>
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
              )}
            </div>
          )
        },
        sortable: false,
      }
    ];

    const customStyles = {
      rows: {
        style: {
          minHeight: '25px',
        },
      },
      headCells: {
        style: {
          padding: '8px',
        },
      },
      cells: {
        style: {
          padding: '8px',
        },
      },
    };

    const paginationComponentOptions = {
      rowsPerPageText: '',
      rangeSeparatorText: '',
      selectAllRowsItem: true,
      selectAllRowsItemText: '',
      noRowsPerPage: '',
    };

    return (
      <>
        <div className="dashboard-block">
          <Sidebar />
          <div className="dash-left">
            <Header />

            <section className="cart-block">
              <div className="container">
                <h1 className="checkout-title">Development Chef</h1>

                <div className="right-table-outer-wrap">
                  <div className="table-filter search-orders">
                    <div className="table-search-reset">
                      <div className="table-search">
                        <input
                          type="text"
                          value={this.state.searchTextVal}
                          onChange={e => this.handleChange(e.target.value)}
                          className="form-control"
                          placeholder="Search by Group Name"
                        />
                      </div>
                      <button className='submitbtn button' onClick={e => this.filterData(this.state.searchTextVal)}>
                        <i className="fa fa-search"></i>
                      </button>

                      <button className='resetbtn' type='reset' onClick={this.handleReset}>Reset</button>
                    </div>
                    {canAction('manage_chefs', 'add') && (
                    <div className='add-holidaybtn'>
                      <button className='addbtn' onClick={this.addChef}>Add</button>
                    </div>
                     )}
                  </div>

                  <div className="table_overflow dev-chef-data-table">
                    <DataTable
                      columns={columns}
                      noDataComponent={<div className='no-records-found'>Sorry, there are no development chef matching your keyword, try a new search.</div>}
                      data={this.state.chefsList}
                      customStyles={customStyles}
                      pagination
                      paginationPerPage={25}
                      progressPending={this.state.loading}
                      paginationRowsPerPageOptions={[25, 50, 75, 100]}
                      paginationComponentOptions={paginationComponentOptions}
                    />
                  </div>
                </div>
              </div>
            </section>

            <Footer />
          </div>
        </div>

        {this.state.visibleAlert === true && (
          <div className='custom-alert-pop paylater-popup'>
            <div className='custom-alert-container'>
              <div className='custom-alert-wrap'>
                <div className='custom-alert-header'>
                  <h4>Alert</h4>
                </div>
                <div className='custom-alert-body'>
                  <p>Are you sure you want to delete this chef?</p>
                  <div className='alert-buttons'>
                    <a onClick={this.deleteChefDetails} className="popup-alert-btn button">OK</a>
                    <a onClick={this.alertPopupClose} className="popup-alert-btn button">Cancel</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* VIEW CHEF POPUP */}
        {this.state.showViewPopup && this.state.selectedChefDetails && (
          <Popup
            extClass="order-pop info-poup"
            headMoreTxt={
              <div className="order-top">
                <div className="head">
                  <h4>
                    Development Chef Details 
                  </h4>
                </div>
              </div>
            }
            bodyMoreTxt={
              <div className="order-top">
                <div className="bottom vendor-details vendor-table-view">
                  <table className="vendor-table">
                    <tr>
                      <td>Group Name</td>
                      <td>{this.state.selectedChefDetails.groupName || "-"}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>
                        {capitalizeFirstLetter(
                          this.state.selectedChefDetails.groupStatus
                        ) || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>Price Band</td>
                      <td>
                        {this.state.selectedChefDetails.priceBand &&
                        this.state.selectedChefDetails.priceBand.length > 0
                          ? this.state.selectedChefDetails.priceBand.join(", ")
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>Primary Account</td>
                      <td>
                        {this.state.selectedChefDetails.primaryAccount
                          ? `${this.state.selectedChefDetails.primaryAccount.accountCode}`
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>Sub Accounts</td>
                      <td>
                        {this.state.selectedChefDetails.accounts &&
                        this.state.selectedChefDetails.accounts.length > 0
                          ? this.state.selectedChefDetails.accounts
                              .map(
                                (acc) => `${acc.accountCode}`
                              )
                              .join(", ")
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>Created On</td>
                      <td>
                        {moment(
                          this.state.selectedChefDetails.createdAt
                        ).format("DD-MM-YYYY HH:mm A")}
                      </td>
                    </tr>
                    <tr>
                      <td>Updated On</td>
                      <td>
                        {moment(
                          this.state.selectedChefDetails.updatedAt
                        ).format("DD-MM-YYYY HH:mm A")}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            }
            closebtn={
              <span
                onClick={this.closeViewPopup}
                className="close"
              ></span>
            }
          />
        )}
      </>
    );
  }
}

export default Chefs;
